import React, { PropTypes }   from 'react';
import ReactDOM from 'react-dom';
import Reflux from 'reflux';
import $ from 'jquery';
import cx from 'classnames';
import Utils from 'medscape/utils';
import CirclePlayIcon from 'grommet/components/icons/base/CirclePlay';

const isLocal = window.medscape.config.env=='localhost';
const imageServerHost = isLocal ? '//img.proddev.medscapestatic.com' : window.medscape.config.staticServer.host;

export default class VideoItem extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  componentDidUpdate() { }
  getPosterContainer() {
    let poster = this.props.poster.replace(/^en\//, '');
    poster = Utils.getCompiledHtml(poster);
    poster = poster.startsWith('/build/') || poster.startsWith('http') ? poster : `${imageServerHost}${poster}`;
    return {
      className: cx({
        "poster-container": true
      }),
      style:{
        backgroundImage: `url(${poster})`
      }
    }
  }
  getVideoItemContainer() {
    return {
      className: cx({
        "video-item-container": true,
        "watched": this.props.watched,
        "playing": this.props.playing
      }),
      onClick: (e)=>{
        e.preventDefault();
        if(!this.props.playing){
          this.props.onClick(this.props["video-config-id"]);
        }
      }
    }
  }
  render() {
    let title = Utils.getDangerousHtml(this.props.title);
    let description = Utils.getDangerousHtml(this.props.description);
    return (
        <div {...this.getVideoItemContainer()}>
          <div {...this.getPosterContainer() }>
            <span className="play-icon"><CirclePlayIcon /></span>
            <Label watched={this.props.watched} playing={this.props.playing} />
          </div>
          <div className="description">
            <span dangerouslySetInnerHTML={description}></span>
          </div>
          <div className="title">
              <span dangerouslySetInnerHTML={title}></span>
          </div>
        </div>
    );
  }
}

VideoItem.propTypes = {
  "video-config-id": PropTypes.string.isRequired,
  "title": PropTypes.string,
  "poster": PropTypes.string,
  "description": PropTypes.string,
  "watched": PropTypes.bool,
  "playing": PropTypes.bool,
  "onClick": PropTypes.func
};
VideoItem.defaultProps = {
 "label": "",
 "title": "",
 "poster": "",
 "description": "",
 "watched": false,
 "playing": false,
 "onClick": ()=>{}
};

class Label extends React.Component{
  render() {
    if(this.props.playing) {
      return (<div className="label playing">Now Playing</div>);
    } else if(this.props.watched) {
      return(<div className="label watched">Watched</div>);
    }
    return false;
  }
}
Label.propTypes={
  "watched": PropTypes.bool,
  "playing": PropTypes.bool
};
Label.defaultProps={
 "watched": false,
 "playing": false
};



// WEBPACK FOOTER //
// ./medscape_modules/video/playlist/video-item.jsx